import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Register the design system's custom spacing scale (see globals.css @theme
// `--spacing-*`) with tailwind-merge so it recognizes utilities like
// `gap-section` / `p-card` as spacing utilities and dedupes them against core
// resets (`gap-0`, `p-0`, `pt-0`). Without this, a base component's `p-card`
// and an instance's `p-0` would BOTH survive the merge and CSS source order
// would silently decide the winner — breaking every card that resets the base
// Card's padding/gap for media-flush layouts. Keep this list in sync with the
// custom `--spacing-*` keys in globals.css.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ['grid', 'heading', 'section', 'card', 'card-compact', 'card-snug'],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
